module.exports = __webpack_public_path__ + "img/docs.9eefb297.png";